import api from "..";
import Env from '../../config/environments';
import { ApiEndpoint, Method } from "../../constants";

const params = {};
const body = {};
export const getTeacherSubjectSubscription = (teacherId ) => {
    return api(`${ApiEndpoint.TEACHER_SUBCRIPTION}/teacher/${teacherId}`, Method.GET, params, Env.BASE_URL, body);
};
